module.exports = __webpack_public_path__ + "img/wen2.a4437685.png";